import { usePrivy } from '@privy-io/react-auth';
import { handleNotificationsLogout } from '../serviceWorkerRegistration';

import useUserStore from '../stores/user.store';
import { isTelegram } from '../utils/browser';

function useCustomLogout() {
  const { logout } = usePrivy();
  const setUser = useUserStore((state) => state.setUser);

  const customLogout = async () => {
    handleNotificationsLogout(localStorage.getItem('fishAuth'));
    localStorage.removeItem('fishAuth');
    localStorage.removeItem('refreshToken');
    await logout();
    setUser(null);

    if (isTelegram) {
      window.Telegram?.WebApp?.close?.();
    }
  };

  return { customLogout };
}

export default useCustomLogout;
